import React, { useEffect, useState } from 'react';

import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from 'components/CustomButtons/Button.js';
import { Edit } from '@material-ui/icons';

import ModalFull from 'components/Tvendo/Common/ModalFull';
import { wsFindBy } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import { useModal } from 'hooks/useModal';
import ModalPaymentBureau from './PaymentBureauModal';

export default WithApp(function ModalIndexPaymentTerm(props) {
  const { open, setOpen, bPartner, showNotify, reload } = props;

  const [bureaus, setBureaus] = useState([]);
  const [model, setOpenUpdate] = useModal(); //uso de las funciones del modal

  async function listBureau() {
    let response = await wsFindBy(`base/business-partner/${bPartner.id}/payment-bureau`);
    if (response.success) setBureaus(response.data);
  }

  useEffect(() => {
    if (open) {
      listBureau();
    }
  }, [open, reload]);

  return (
    <>
      <ModalPaymentBureau
        model={model}
        setOpen={setOpenUpdate}
        showNotify={showNotify}
        reload={reload}
        bPartner={bPartner}
      />
      <ModalFull
        title={`${bPartner.CardCode} - ${bPartner.CardName}`}
        open={open}
        setOpen={setOpen}
        showNotify={showNotify}
      >
        <TableContainer component={Paper}>
          <Table style={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Término pago</TableCell>
                <TableCell>Monto</TableCell>
                <TableCell>Mesa</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bureaus.map((bureau, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell>
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_BUREAU_UPDATE}
                      >
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          size="sm"
                          onClick={() => {
                            setOpenUpdate(bureau);
                          }}
                        >
                          <Edit />
                        </Button>
                      </AllowedGuard>
                    </TableCell>
                    <TableCell>{bureau.PymntGroup}</TableCell>
                    <TableCell>{bureau.creditLine}</TableCell>
                    <TableCell>{`${bureau.base_bureau_code} - ${bureau.base_bureau_description}`}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </ModalFull>
    </>
  );
});
